import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function NewsTNHNavDetails(props) {
    const {news} = props;
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {label: getLocaleContent(locale, 'page.news-page.page-title'), href: '/tin-tuc', color: '#006940'},
                    {label: news?.news_category_name || getLocaleContent(locale, 'page.news-page.news-detail')},
                ]}
            />
        </div>
    );
}

export default NewsTNHNavDetails;
